import { render } from "./CaptionSettingsPanel.vue?vue&type=template&id=19fefb24"
import script from "./CaptionSettingsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptionSettingsPanel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/CaptionSettingsPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19fefb24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19fefb24', __exports__)) {
    api.reload('19fefb24', __exports__)
  }
  
  module.hot.accept("./CaptionSettingsPanel.vue?vue&type=template&id=19fefb24", () => {
    api.rerender('19fefb24', render)
  })

}


export default __exports__